import { createAction } from 'redux-actions';
import Types from './types';

export const newOperatorRequest = createAction(Types.NEW_OPERATOR_REQUEST);
export const newOperatorFulfilled = createAction(Types.NEW_OPERATOR_FULFILLED);
export const newOperatorRejected = createAction(Types.NEW_OPERATOR_REJECTED);

export const newOperatorAtGroupRequest = createAction(
  Types.NEW_OPERATOR_AT_GROUP_REQUEST
);
export const newOperatorAtGroupFulfilled = createAction(
  Types.NEW_OPERATOR_AT_GROUP_FULFILLED
);
export const newOperatorAtGroupRejected = createAction(
  Types.NEW_OPERATOR_AT_GROUP_REJECTED
);

export const changeLanguageRequest = createAction(
  Types.CHANGE_LANGUAGE_REQUEST
);
export const changeLanguageFulfilled = createAction(
  Types.CHANGE_LANGUAGE_FULFILLED
);
export const changeLanguageRejected = createAction(
  Types.CHANGE_LANGUAGE_REJECTED
);

export const resetMFAToOperatorRequest = createAction(
  Types.RESET_MFA_TO_OPERATOR_REQUEST
);
export const resetMFAToOperatorFulfilled = createAction(
  Types.RESET_MFA_TO_OPERATOR_FULFILLED
);
export const resetMFAToOperatorRejected = createAction(
  Types.RESET_MFA_TO_OPERATOR_REJECTED
);

export const updatePermissionsRequest = createAction(
  Types.UPDATE_PERMISSIONS_REQUEST
);
export const updatePermissionsFulfilled = createAction(
  Types.UPDATE_PERMISSIONS_FULFILLED
);
export const updatePermissionsRejected = createAction(
  Types.UPDATE_PERMISSIONS_REJECTED
);

export const enableOrDisableMFAOperatorRequest = createAction(
  Types.ENABLE_OR_DISABLE_MFA_OPERATOR_REQUEST
);
export const enableOrDisableMFAOperatorFulfilled = createAction(
  Types.ENABLE_OR_DISABLE_MFA_OPERATOR_FULFILLED
);
export const enableOrDisableMFAOperatorRejected = createAction(
  Types.ENABLE_OR_DISABLE_MFA_OPERATOR_REJECTED
);

export const removeOperatorRequest = createAction(
  Types.REMOVE_OPERATOR_REQUEST
);
export const removeOperatorFulfilled = createAction(
  Types.REMOVE_OPERATOR_FULFILLED
);
export const removeOperatorRejected = createAction(
  Types.REMOVE_OPERATOR_REJECTED
);

export const resetPasswordRequest = createAction(Types.RESERT_PASSWORD_REQUEST);
export const resetPasswordFulfilled = createAction(
  Types.RESERT_PASSWORD_FULFILLED
);
export const resetPasswordRejected = createAction(
  Types.RESERT_PASSWORD_REJECTED
);

export const editOperatorRequest = createAction(Types.EDIT_OPERATOR_REQUEST);
export const editOperatorFulfilled = createAction(
  Types.EDIT_OPERATOR_FULFILLED
);
export const editOperatorRejected = createAction(Types.EDIT_OPERATOR_REJECTED);

export const getOperatorRequest = createAction(Types.GET_OPERATOR_REQUEST);
export const getOperatorFulfilled = createAction(Types.GET_OPERATOR_FULFILLED);
export const getOperatorRejected = createAction(Types.GET_OPERATOR_REJECTED);

export const getAllOperatorsRequest = createAction(
  Types.GET_ALL_OPERATORS_REQUEST
);
export const getAllOperatorsFulfilled = createAction(
  Types.GET_ALL_OPERATORS_FULFILLED
);
export const getAllOperatorsRejected = createAction(
  Types.GET_ALL_OPERATORS_REJECTED
);

export const getOperatorTokensRequest = createAction(
  Types.GET_OPERATOR_TOKENS_REQUEST
);
export const getOperatorTokensFulfilled = createAction(
  Types.GET_OPERATOR_TOKENS_FULFILLED
);
export const getOperatorTokensRejected = createAction(
  Types.GET_OPERATOR_TOKENS_REJECTED
);

export const newOperatorTokenRequest = createAction(
  Types.NEW_OPERATOR_TOKEN_REQUEST
);
export const newOperatorTokenFulfilled = createAction(
  Types.NEW_OPERATOR_TOKEN_FULFILLED
);
export const newOperatorTokenRejected = createAction(
  Types.NEW_OPERATOR_TOKEN_REJECTED
);

export const removeOperatorTokenRequest = createAction(
  Types.REMOVE_OPERATOR_TOKEN_REQUEST
);
export const removeOperatorTokenFulfilled = createAction(
  Types.REMOVE_OPERATOR_TOKEN_FULFILLED
);
export const removeOperatorTokenRejected = createAction(
  Types.REMOVE_OPERATOR_TOKEN_REJECTED
);

export const editOperatorTokenRequest = createAction(
  Types.EDIT_OPERATOR_TOKEN_REQUEST
);
export const editOperatorTokenFulfilled = createAction(
  Types.EDIT_OPERATOR_TOKEN_FULFILLED
);
export const editOperatorTokenRejected = createAction(
  Types.EDIT_OPERATOR_TOKEN_REJECTED
);

export const toggleBlockOperatorRequest = createAction(
  Types.TOGGLE_BLOCK_OPERATOR_REQUEST
);
export const toggleBlockOperatorFulfilled = createAction(
  Types.TOGGLE_BLOCK_OPERATOR_FULFILLED
);
export const toggleBlockOperatorRejected = createAction(
  Types.TOGGLE_BLOCK_OPERATOR_REJECTED
);

export const updateMFARequest = createAction(Types.UPDATE_MFA_REQUEST);
export const updateMFAFulfilled = createAction(Types.UPDATE_MFA_FULFILLED);
export const updateMFARejected = createAction(Types.UPDATE_MFA_REJECTED);

export const setPendingPermissionsRequest = createAction(
  Types.SET_PENDING_PERMISSIONS_REQUEST
);

export const getOperatorRolesRequest = createAction(
  Types.GET_OPERATOR_ROLES_REQUEST
);
export const getOperatorRolesFulfilled = createAction(
  Types.GET_OPERATOR_ROLES_FULFILLED
);
export const getOperatorRolesRejected = createAction(
  Types.GET_OPERATOR_ROLES_REJECTED
);
